import { Component, effect, inject, Input } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { FormGroup } from '@angular/forms';
import { IndicatorStore } from '../../../../../stores/indicator/indicator.state';
import { Indicator } from '../../../../../models/indicator';
import { getState } from '@ngrx/signals';
import { WidgetStore } from '../../../../../stores/grid/widget.state';
import {
  CustomGridStackWidget,
  WegweiserIndicator,
} from '../../../../../services/grid-widget-config.service';
import { CardModule } from 'primeng/card';
import { StyleClassModule } from 'primeng/styleclass';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { IndicatorMetaDataComponent } from '../../../../molecules/indicator-meta-data/indicator-meta-data.component';
import { WegweiserStore } from '../../../../../stores/wegweiser-api/wegweiser.state';

@Component({
  selector: 'app-info',
  standalone: true,
  imports: [
    CarouselModule,
    CardModule,
    StyleClassModule,
    ScrollPanelModule,
    IndicatorMetaDataComponent,
  ],
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss',
})
export class InfoComponent {
  readonly indicatorStore = inject(IndicatorStore);
  readonly wegweiserStore = inject(WegweiserStore);
  readonly widgetStore = inject(WidgetStore);
  protected config: CustomGridStackWidget | null = null;

  @Input() id = '';
  @Input() indicators: Indicator[] | WegweiserIndicator[] | null = null;

  constructor() {
    effect(() => {
      const indicatorState = getState(this.indicatorStore);
      const widgetState = getState(this.widgetStore);

      if (!this.id) return;

      this.config = this.widgetStore.get(this.id);
      const widget = this.config?.widget || null;
      if (!widget) {
        this.indicators = null;
        return;
      }

      if (widget.context !== 'external') {
        this.indicators =
          widget.indicators
            ?.map(indicatorId => this.indicatorStore.getById(indicatorId))
            .filter(indicator => !!indicator) || [];
      } else {
        this.indicators =
          widget.indicators
            ?.map(indicatorId =>
              this.wegweiserStore.getWegweiserIndicatorById(indicatorId)
            )
            .filter(indicator => !!indicator) || [];
      }
    });
  }
}
